import React, { useState } from "react";
import "../css/ModalPopUp.css";
import MasjidKertayasaSlider from "./slider/MasjidKertayasaSlider";
import Footer from "../../../../../../Footer";

export default function MasjidKertayasa() {

  return (
    <div className="modal-img">
        <MasjidKertayasaSlider/>
        <Footer/>
    </div>
  );
}